import { render, staticRenderFns } from "./VLoading.vue?vue&type=template&id=4ac63089&scoped=true"
import script from "./VLoading.vue?vue&type=script&lang=js"
export * from "./VLoading.vue?vue&type=script&lang=js"
import style0 from "./VLoading.vue?vue&type=style&index=0&id=4ac63089&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac63089",
  null
  
)

export default component.exports